import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Detail.css';

// 상세 화면 상단. 목록으로 돌아가는 링크와 제목, 오른쪽 부가 요소(배지 등)를 보여준다.
export default function DetailHeader({ backTo, backLabel, title, aside }) {
    return (
        <header className="admin-detail-header">
            <Link to={backTo} className="admin-detail-back">← {backLabel}</Link>
            <div className="admin-detail-title">
                <h1>{title}</h1>
                {aside}
            </div>
        </header>
    );
}

DetailHeader.propTypes = {
    backTo: PropTypes.string.isRequired,
    backLabel: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    aside: PropTypes.node,
};
